import { useEffect, memo } from 'react'
import useSound from 'use-sound'
const slow = require("./slowBackground.mp3");
// const fast = require("./fastBackground.mp3");
const fast = require("./fastBackground2.mp3");

interface Props {
    audio: any
    errorText: any
    isLoaded: boolean
    speed: number
}

function Audio({ audio, errorText, isLoaded, speed }: Props) {
    const [slowSFX, { stop: stopSL, sound: soundSL }] = useSound(slow.default, {
        volume: parseFloat(audio.volume),
    });
    const [fastSFX, { stop: stopFS, sound: soundFS }] = useSound(fast.default, {
        volume: parseFloat(audio.volume),
    });
    useEffect(() => {
        if (speed === 1) {
            audio.music && errorText === false && isLoaded
                ? (() => {
                    slowSFX();
                    if (soundSL) {
                        soundSL.loop(true);
                    }
                })()
                : stopFS();
        }
        if (speed === 2) {
            audio.music && errorText === false && isLoaded
                ? (() => {
                    fastSFX();
                    if (soundFS) {
                        soundFS.loop(true);
                    }
                })()
                : stopFS();
        }
        return () => {
            stopSL();
            stopFS();
        }

    }, [audio.music, errorText, isLoaded, fastSFX, slowSFX, soundFS, soundSL, speed, stopFS, stopSL]);





    return (
        null
    )
}

export default memo(Audio)